<h1 mat-dialog-title>{{ 'INVENTORY_UI.COMMON.ACTIONS.ADD_ITEMS' | translate }}</h1>
<mat-dialog-content class="item-selector-dialog-content">
  <div class="item-selector">
    <inventory-ui-item-selector
      [config]="data.config"
      [selectedItems]="data.selectedItems"
      [immutableSelectedItems]="data.immutableSelectedItems"
      [availableItems]="data.availableItems"
    />
  </div>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-stroked-button matDialogClose tabindex="-1">
    {{ 'INVENTORY_UI.COMMON.ACTIONS.CANCEL' | translate }}
  </button>
  <button mat-flat-button color="primary" (click)="onSelect()">
    {{ 'INVENTORY_UI.COMMON.ACTIONS.SELECT' | translate }}
  </button>
</mat-dialog-actions>
